import { push } from "connected-react-router";
import { put, select, takeLatest } from "redux-saga/effects";

import { MapLeadsResponse } from "@mapmycustomers/shared/types/map";

import {
  clearLeadFinderLocation,
  clearLeadFinderRecords,
  enterLeadFinderMode,
  exitLeadFinderMode,
  initializeLeadFinderMode,
  setConfigurationVisibility,
  setCurrentBounds,
  setLeadAnnotation,
} from "@app/component/leadFinder/store/actions";
import { getLeadFinderRecords } from "@app/component/leadFinder/store/selectors";
import MapMode from "@app/enum/map/MapMode";
import Path from "@app/enum/Path";
import { enterMode, exitMode, hideSidebar } from "@app/scene/map/store/actions";
import { handleError } from "@app/store/errors/actions";

function* onInitializeLeadFinderMode({
  payload,
}: ReturnType<typeof initializeLeadFinderMode.request>) {
  try {
    yield put(enterMode(MapMode.LEAD_FINDER));

    const records: MapLeadsResponse["data"] = yield select(getLeadFinderRecords);

    if (payload.callback) {
      const bounds = new google.maps.LatLngBounds();
      records.forEach((lead) => {
        if (lead.geometry?.location) {
          bounds.extend(lead.geometry.location);
        }
      });

      payload.callback(bounds.isEmpty() ? undefined : bounds);
    }

    yield put(initializeLeadFinderMode.success());
  } catch (error) {
    yield put(initializeLeadFinderMode.failure());
    yield put(handleError({ error }));
  }
}

function* onEnterLeadFinderMode() {
  try {
    yield put(hideSidebar());
    yield put(enterMode(MapMode.LEAD_FINDER));

    yield put(setConfigurationVisibility({ visible: false }));

    yield put(push(`${Path.MAP}/leads`));
  } catch (error) {
    yield put(handleError({ error }));
  }
}

function* onExitLeadFinderMode() {
  try {
    yield put(hideSidebar());
    yield put(exitMode());

    yield put(clearLeadFinderLocation());
    yield put(clearLeadFinderRecords());
    yield put(setCurrentBounds({ bounds: undefined }));
    yield put(setLeadAnnotation(undefined));

    yield put(push(Path.MAP));
  } catch (error) {
    yield put(handleError({ error }));
  }
}

export function* leadFinderModeSagas() {
  yield takeLatest(initializeLeadFinderMode.request, onInitializeLeadFinderMode);
  yield takeLatest(enterLeadFinderMode, onEnterLeadFinderMode);
  yield takeLatest(exitLeadFinderMode, onExitLeadFinderMode);
}
